import { baseBackend } from "../../../api/base/baseUrl";

const URL_PICTURE = "/api/v1/module/image";

export const createPictureList = async (filename, picture) => {
  return await baseBackend.post(
    URL_PICTURE,
    JSON.stringify({ filename, picture }),
    { headers: { "Content-Type": "application/json" } }
  );
};

export const createPictureTour = async (relation) => {
  return await baseBackend.post(
    `${URL_PICTURE}-tour`,
    JSON.stringify({ relation }),
    { headers: { "Content-Type": "application/json" } }
  );
};

export const getPictureList = async () => {
  return await baseBackend.get(`${URL_PICTURE}/list`, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getPictureHasTour = async () => {
  return await baseBackend.get(`${URL_PICTURE}-has-tour`, {
    headers: { "Content-Type": "application/json" },
  });
};

export const createFilenameTour = async (filename) => {
  return await baseBackend.post(
    `${URL_PICTURE}-file`,
    JSON.stringify({ filename }),
    { headers: { "Content-Type": "application/json" } }
  );
};
